import { render, staticRenderFns } from "./CatalogIcon.vue?vue&type=template&id=3e75ccfa"
import script from "./CatalogIcon.vue?vue&type=script&lang=js"
export * from "./CatalogIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports